import { sanguine, spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Typography, TypographyProps, styled } from '@mui/material';

interface DetectionInformationProps extends TypographyProps {
  isHighlighted: boolean;
  isFromClient?: boolean;
}

const StyledTypography = styled((props: DetectionInformationProps) => {
  const { isHighlighted, isFromClient, ...other } = props;
  return <Typography {...other} />;
})(({ isHighlighted, isFromClient }) => ({
  fontSize: 9,
  lineHeight: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  color: isHighlighted ? ultraMarine[500] : spaceCadet[400],
  '& strong': {
    color: isHighlighted ? ultraMarine[500] : spaceCadet[500],
  },

  '& > .MuiSvgIcon-root': {
    fontSize: 14,
    color: isFromClient ? sanguine[400] : ultraMarine[400],
  },
}));

export default StyledTypography;
